import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';

class Service extends React.Component {
   render() {
      return (
         <div>
            <Navbar>
               <Navbar.Header>
                  <Navbar.Brand>
                     <Link to="/service/" activeStyle={{ color: 'red' }} >Services</Link>
                  </Navbar.Brand>
               </Navbar.Header>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to="/service/" activeStyle={{ color: 'red' }} >All</IndexLink>
                  </li>
                  <li>
                     <Link to="/service/newItem" activeStyle={{ color: 'red' }} >New</Link>
                  </li>
               </ul>

            </Navbar>
            {this.props.children}
         </div>
      );
   }
}
Service.propTypes = {
   children: React.PropTypes.object
};
export default Service;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Service/Service.js
 **/